module.exports = __webpack_public_path__ + "static/media/dca_harryaxewound.956f30b7.png";